import {
  getAdlData,
  getADXData,
  getBollingerBandsData,
  getCCIData,
  getCMFData,
  getEFIData,
  getEMAData,
  getMACDData,
  getMACDHData,
  getMFIData,
  getOBVData,
  getPPOData,
  getPsarData,
  getPVOData,
  getROCData,
  getRSIData,
  getSMAData,
  getSTOCHData,
} from "../utils/api";
import { toast } from "react-toastify";

export function fetchChartsData(
  tickerFromLocalStorage,
  setting,
  setOverlays,
  setOverlayloader,
  seterror,
  setIndicators,
  setIndicatorloader
) {
  const fetchBollingerData = async (item, index) => {
    const bollingerParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      length: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      let data = [];
      if (bollingerParams.length && bollingerParams.length.includes(",")) {
        // Split the length parameter by commas and remove spaces
        let numbersArray = bollingerParams.length
          .split(",")
          .map((s) => s.trim());

        // Convert string values to numbers
        const length = Number(numbersArray[0]);
        const stdDev = Number(numbersArray[1]);

        // Additional validation for numeric values
        if (isNaN(length) || isNaN(stdDev)) {
          throw new Error(
            "Invalid parameters. Length and standard deviation must be numeric."
          );
        }

        // Fetch data with the validated and parsed parameters
        data = await getBollingerBandsData(
          bollingerParams.symbol,
          bollingerParams.period,
          length,
          stdDev,
          bollingerParams?.multiplier
        );
      } else {
        // If bollingerParams.length is not in the expected format, throw an error
        data = await getBollingerBandsData(
          bollingerParams.symbol,
          bollingerParams.period,
          bollingerParams.length,
          "",
          bollingerParams?.multiplier
        );
      }

      /* setOverlays((currentOverlays) => [
        ...currentOverlays.slice(0, index),
        { type: item.selectValue, data },
        ...currentOverlays.slice(index + 1),
      ]); */

      setOverlays((currentOverlays) => {
        const newOverlays = [...currentOverlays];

        // Ensure the array has enough elements
        while (newOverlays.length <= index) {
          newOverlays.push({});
        }

        // Fill any gaps with empty objects, only if they are actually empty
        for (let i = 0; i < index; i++) {
          if (!newOverlays[i] || Object.keys(newOverlays[i]).length === 0) {
            newOverlays[i] = {};
          }
        }

        // Set the new data at the specified index
        newOverlays[index] = { type: item.selectValue, data };

        return newOverlays;
      });

      setOverlayloader(false);
    } catch (error) {
      toast.error("Something went wrong, please refresh the screen");
      setOverlayloader(false);
      seterror("Something went wrong; please refresh the screen");
      console.error("Error fetching Bollinger Bands data:", error);
    }
  };

  const fetchPsarData = async (item, index) => {
    const psarParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      length: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      let data = [];
      if (psarParams.length && psarParams.length.includes(",")) {
        let numbersArray = psarParams.length.split(",").map((s) => s.trim());

        if (numbersArray.length < 2) {
        }
        const length = Number(numbersArray[0]);
        const stdDev = Number(numbersArray[1]);
        if (isNaN(length) || isNaN(stdDev)) {
          throw new Error(
            "Invalid parameters. Length and standard deviation must be numeric."
          );
        }
        data = await getPsarData(
          psarParams.symbol,
          psarParams.period,
          length,
          stdDev,
          psarParams?.multiplier
        );
      } else {
        data = await getPsarData(
          psarParams.symbol,
          psarParams.period,
          psarParams.length,
          "",
          psarParams?.multiplier
        );
      }

      /* setOverlays((currentOverlays) => [
        ...currentOverlays.slice(0, index),
        { type: item.selectValue, data },
        ...currentOverlays.slice(index + 1),
      ]); */

      setOverlays((currentOverlays) => {
        const newOverlays = [...currentOverlays];

        // Ensure the array has enough elements
        while (newOverlays.length <= index) {
          newOverlays.push({});
        }

        // Fill any gaps with empty objects, only if they are actually empty
        for (let i = 0; i < index; i++) {
          if (!newOverlays[i] || Object.keys(newOverlays[i]).length === 0) {
            newOverlays[i] = {};
          }
        }

        // Set the new data at the specified index
        newOverlays[index] = { type: item.selectValue, data };

        return newOverlays;
      });

      setOverlayloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchSmaData = async (item, index) => {
    const smaParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      length: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      const data = await getSMAData(...Object.values(smaParams));

      /* setOverlays((currentOverlays) => [
        ...currentOverlays.slice(0, index),
        { type: item.selectValue, data },
        ...currentOverlays.slice(index + 1),
      ]); */

      console.log("fetchSmaData --------------------- ", data);

      setOverlays((currentOverlays) => {
        const newOverlays = [...currentOverlays];

        // Ensure the array has enough elements
        while (newOverlays.length <= index) {
          newOverlays.push({});
        }

        // Fill any gaps with empty objects, only if they are actually empty
        for (let i = 0; i < index; i++) {
          if (!newOverlays[i] || Object.keys(newOverlays[i]).length === 0) {
            newOverlays[i] = {};
          }
        }

        // Set the new data at the specified index
        newOverlays[index] = { type: item.selectValue, data };

        return newOverlays;
      });
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching SMA data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchEmaData = async (item, index) => {
    const emaParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      length: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      const data = await getEMAData(...Object.values(emaParams));
      /* setOverlays((currentOverlays) => [
        ...currentOverlays.slice(0, index),
        { type: item.selectValue, data },
        ...currentOverlays.slice(index + 1),
      ]); */

      setOverlays((currentOverlays) => {
        const newOverlays = [...currentOverlays];

        // Ensure the array has enough elements
        while (newOverlays.length <= index) {
          newOverlays.push({});
        }

        // Fill any gaps with empty objects, only if they are actually empty
        for (let i = 0; i < index; i++) {
          if (!newOverlays[i] || Object.keys(newOverlays[i]).length === 0) {
            newOverlays[i] = {};
          }
        }

        // Set the new data at the specified index
        newOverlays[index] = { type: item.selectValue, data };

        return newOverlays;
      });
      setOverlayloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchAdlData = async (item, index) => {
    const adlParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      multiplier: setting?.multiplier,
    };
    try {
      const data = await getAdlData(...Object.values(adlParams));
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const updateIndicatorData = (data, item, index) => {
    setIndicators((currentIndicators) => {
      const newIndications = [...currentIndicators];

      console.log(
        "newIndications, item, index",
        newIndications.length,
        newIndications,
        item,
        index
      );

      // Ensure the array has enough elements
      while (newIndications.length <= index) {
        newIndications.push({});
      }

      // Fill any gaps with empty objects, only if they are actually empty
      for (let i = 0; i < index; i++) {
        if (!newIndications[i] || Object.keys(newIndications[i]).length === 0) {
          newIndications[i] = {};
        }
      }

      // Set the new data at the specified index
      newIndications[index] = { type: item.selectValue, data };

      return newIndications;
    });
  };

  const fetchAdxData = async (item, index) => {
    const adxParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      value: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      let data = [];
      if (adxParams.value && adxParams.value.includes(",")) {
        let numbersArray = adxParams.value.split(",").map((s) => s.trim());

        if (numbersArray.length < 2) {
        }
        const length = Number(numbersArray[0]);
        const stdDev = Number(numbersArray[1]);
        if (isNaN(length) || isNaN(stdDev)) {
          throw new Error(
            "Invalid parameters. Length and standard deviation must be numeric."
          );
        }
        data = await getADXData(
          adxParams.symbol,
          adxParams.period,
          length,
          stdDev,
          adxParams?.multiplier
        );
      } else {
        data = await getADXData(
          adxParams.symbol,
          adxParams.period,
          adxParams.value,
          "",
          adxParams?.multiplier
        );
      }

      setIndicators((currentIndicators) => [
        ...currentIndicators.slice(0, index),
        { type: item.selectValue, data },
        ...currentIndicators.slice(index + 1),
      ]);

      // SD
      updateIndicatorData(data, item, index);

      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchRSIData = async (item, index) => {
    const rsiParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      length: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      const data = await getRSIData(...Object.values(rsiParams));
      setIndicatorloader(false);
      // SD
      updateIndicatorData(data, item, index);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchStochData = async (item, index) => {
    const stochParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      multiplier: setting?.multiplier,
    };
    try {
      let fast = 14;
      let slow = 3;
      let smooth_k = 3;
      if (item.inputValue && item.inputValue.includes(",")) {
        let numbersArray = item.inputValue.split(",").map((s) => s.trim());

        if (numbersArray.length < 3) {
        }
        fast = Number(numbersArray[0]);
        slow = Number(numbersArray[1]);
        smooth_k = Number(numbersArray[2]);
        if (isNaN(fast) || isNaN(slow) || isNaN(smooth_k)) {
          throw new Error(
            "Invalid parameters. Length and standard deviation must be numeric."
          );
        }
      }
      const data = await getSTOCHData(
        ...Object.values(stochParams),
        fast,
        slow,
        smooth_k
      );
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchMacdhData = async (item, index) => {
    const macdhParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      multiplier: setting?.multiplier,
    };
    try {
      let fast = 12;
      let slow = 26;
      let signal = 9;
      if (item.inputValue && item.inputValue.includes(",")) {
        let numbersArray = item.inputValue.split(",").map((s) => s.trim());

        if (numbersArray.length < 3) {
        }
        fast = Number(numbersArray[0]);
        slow = Number(numbersArray[1]);
        signal = Number(numbersArray[2]);
        if (isNaN(fast) || isNaN(slow) || isNaN(signal)) {
          throw new Error(
            "Invalid parameters. Length and standard deviation must be numeric."
          );
        }
      }
      const data = await getMACDHData(
        ...Object.values(macdhParams),
        fast,
        slow,
        signal
      );
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchCCIData = async (item, index) => {
    const cciParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      value: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      let data = [];
      if (cciParams.value && cciParams.value.includes(",")) {
        let numbersArray = cciParams.value.split(",").map((s) => s.trim());

        if (numbersArray.length < 2) {
        }
        const length = Number(numbersArray[0]);
        const stdDev = Number(numbersArray[1]);
        if (isNaN(length) || isNaN(stdDev)) {
          throw new Error(
            "Invalid parameters. Length and standard deviation must be numeric."
          );
        }
        data = await getCCIData(
          cciParams.symbol,
          cciParams.period,
          length,
          stdDev,
          cciParams?.multiplier
        );
      } else {
        data = await getCCIData(
          cciParams.symbol,
          cciParams.period,
          cciParams.value,
          "",
          cciParams?.multiplier
        );
      }
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchPPOData = async (item, index) => {
    const ppoParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      value: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      let data = [];
      if (!ppoParams.value || ppoParams.value.trim() === "") {
        throw new Error("MACD parameters are missing or empty.");
      }

      let numbersArray = ppoParams.value.split(",").map((s) => s.trim());

      // Check for empty strings in valueArray and periodArray
      switch (numbersArray.length) {
        case 1:
          const length = Number(numbersArray[0]);
          if (isNaN(length)) {
            throw new Error("Invalid parameter. Length must be numeric.");
          }
          data = await getPPOData(ppoParams.symbol, ppoParams.period, length);
          break;
        case 2:
          const fastLength = Number(numbersArray[0]);
          const slowLength = Number(numbersArray[1]);
          if (isNaN(fastLength) || isNaN(slowLength)) {
            throw new Error(
              "Invalid parameters. Fast length and slow length must be numeric."
            );
          }
          data = await getPPOData(
            ppoParams.symbol,
            ppoParams.period,
            fastLength,
            slowLength,
            "",
            ppoParams?.multiplier
          );
          break;
        case 3:
          const fastLengthThreeParams = Number(numbersArray[0]);
          const slowLengthThreeParams = Number(numbersArray[1]);
          const signalSmoothing = Number(numbersArray[2]);
          if (
            isNaN(fastLengthThreeParams) ||
            isNaN(slowLengthThreeParams) ||
            isNaN(signalSmoothing)
          ) {
            throw new Error(
              "Invalid parameters. Fast length, slow length, and signal smoothing must be numeric."
            );
          }
          data = await getPPOData(
            ppoParams.symbol,
            ppoParams.period,
            fastLengthThreeParams,
            slowLengthThreeParams,
            signalSmoothing,
            ppoParams?.multiplier
          );
          break;
        default:
          throw new Error("Invalid number of parameters provided for MACD.");
      }
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      seterror(error?.message);
      console.error(
        "Error fetching PPO data:",
        error.response?.data?.error || error.message
      );
    }
  };

  const fetchCMFData = async (item, index) => {
    const cmfParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      length: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      const data = await getCMFData(...Object.values(cmfParams));
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchPVOData = async (item, index) => {
    const pvoParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      value: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      let data = [];
      if (pvoParams.value && pvoParams.value.includes(",")) {
        let numbersArray = pvoParams.value.split(",").map((s) => s.trim());

        if (numbersArray.length < 2) {
        }
        const length = Number(numbersArray[0]);
        const stdDev = Number(numbersArray[1]);
        if (isNaN(length) || isNaN(stdDev)) {
          throw new Error(
            "Invalid parameters. Length and standard deviation must be numeric."
          );
        }
        data = await getPVOData(
          pvoParams.symbol,
          pvoParams.period,
          length,
          stdDev,
          pvoParams?.multiplier
        );
      } else {
        data = await getPVOData(
          pvoParams.symbol,
          pvoParams.period,
          pvoParams.value,
          "",
          pvoParams?.multiplier
        );
      }
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchMACDData = async (item, index) => {
    const macdParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      value: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      let data = [];

      // Check if macdParams.value is null, undefined, or an empty string
      if (!macdParams.value || macdParams.value.trim() === "") {
        throw new Error("MACD parameters are missing or empty.");
      }

      let numbersArray = macdParams.value.split(",").map((s) => s.trim());

      switch (numbersArray.length) {
        case 1:
          const length = Number(numbersArray[0]);
          if (isNaN(length)) {
            throw new Error("Invalid parameter. Length must be numeric.");
          }
          data = await getMACDData(
            macdParams.symbol,
            macdParams.period,
            length,
            "",
            "",
            macdParams?.multiplier
          );
          break;
        case 2:
          const fastLength = Number(numbersArray[0]);
          const slowLength = Number(numbersArray[1]);
          if (isNaN(fastLength) || isNaN(slowLength)) {
            throw new Error(
              "Invalid parameters. Fast length and slow length must be numeric."
            );
          }
          data = await getMACDData(
            macdParams.symbol,
            macdParams.period,
            fastLength,
            slowLength,
            "",
            macdParams?.multiplier
          );
          break;
        case 3:
          const fastLengthThreeParams = Number(numbersArray[0]);
          const slowLengthThreeParams = Number(numbersArray[1]);
          const signalSmoothing = Number(numbersArray[2]);
          if (
            isNaN(fastLengthThreeParams) ||
            isNaN(slowLengthThreeParams) ||
            isNaN(signalSmoothing)
          ) {
            throw new Error(
              "Invalid parameters. Fast length, slow length, and signal smoothing must be numeric."
            );
          }
          data = await getMACDData(
            macdParams.symbol,
            macdParams.period,
            fastLengthThreeParams,
            slowLengthThreeParams,
            signalSmoothing,
            macdParams?.multiplier
          );
          break;
        default:
          throw new Error("Invalid number of parameters provided for MACD.");
      }
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error.message);
      seterror(error.message);
      console.error("Error fetching MACD data:", error.message);
    }
  };

  const fetchMFIData = async (item, index) => {
    const mafiParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      value: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      let data = [];
      if (mafiParams.value && mafiParams.value.includes(",")) {
        let numbersArray = mafiParams.value.split(",").map((s) => s.trim());

        if (numbersArray.length < 2) {
        }
        const length = Number(numbersArray[0]);
        const stdDev = Number(numbersArray[1]);
        if (isNaN(length) || isNaN(stdDev)) {
          throw new Error(
            "Invalid parameters. Length and standard deviation must be numeric."
          );
        }
        data = await getMFIData(
          mafiParams.symbol,
          mafiParams.period,
          length,
          stdDev,
          mafiParams?.multiplier
        );
      } else {
        data = await getMFIData(
          mafiParams.symbol,
          mafiParams.period,
          mafiParams.value,
          "",
          mafiParams?.multiplier
        );
      }
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchROCData = async (item, index) => {
    const rocParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      value: item.inputValue,
      multiplier: setting?.multiplier,
    };
    try {
      let data = [];
      if (rocParams.value && rocParams.value.includes(",")) {
        let numbersArray = rocParams.value.split(",").map((s) => s.trim());

        if (numbersArray.length < 2) {
        }
        const length = Number(numbersArray[0]);
        const stdDev = Number(numbersArray[1]);
        if (isNaN(length) || isNaN(stdDev)) {
          throw new Error(
            "Invalid parameters. Length and standard deviation must be numeric."
          );
        }
        data = await getROCData(
          rocParams.symbol,
          rocParams.period,
          length,
          stdDev,
          rocParams?.multiplier
        );
      } else {
        data = await getROCData(
          rocParams.symbol,
          rocParams.period,
          rocParams.value,
          "",
          rocParams?.multiplier
        );
      }
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchOBVData = async (item, index) => {
    const obvParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      multiplier: setting?.multiplier,
    };
    try {
      const data = await getOBVData(...Object.values(obvParams));
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };

  const fetchEFIData = async (item, index) => {
    const efiParams = {
      symbol: tickerFromLocalStorage ? tickerFromLocalStorage : setting.symbol,
      period: setting.period,
      value: item.inputValue,
      multiplier: setting?.multiplier,
    };
    let data = [];
    try {
      if (efiParams.value && efiParams.value.includes(",")) {
        let numbersArray = efiParams.value.split(",").map((s) => s.trim());

        if (numbersArray.length < 2) {
        }
        const length = Number(numbersArray[0]);
        const stdDev = Number(numbersArray[1]);
        if (isNaN(length) || isNaN(stdDev)) {
          throw new Error(
            "Invalid parameters. Length and standard deviation must be numeric."
          );
        }
        data = await getEFIData(
          efiParams.symbol,
          efiParams.period,
          length,
          stdDev,
          efiParams?.multiplier
        );
      } else {
        data = await getEFIData(
          efiParams.symbol,
          efiParams.period,
          efiParams.value,
          "",
          efiParams?.multiplier
        );
      }
      // SD
      updateIndicatorData(data, item, index);
      setIndicatorloader(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message);
      seterror(error?.message);
      console.error(
        "Error fetching Adl data:",
        error.response.data.error || error.message
      );
    }
  };
  return {
    fetchBollingerData,
    fetchPsarData,
    fetchSmaData,
    fetchEmaData,
    fetchAdlData,
    fetchAdxData,
    fetchRSIData,
    fetchStochData,
    fetchMacdhData,
    fetchCCIData,
    fetchPPOData,
    fetchCMFData,
    fetchPVOData,
    fetchMACDData,
    fetchMFIData,
    fetchROCData,
    fetchOBVData,
    fetchEFIData,
  };
}
